import {
  EDIT_COMPANY,
  EDIT_COMPANY_FAILED,
  EDIT_COMPANY_SUCCESS,
  FETCH_COMPANIES,
  FETCH_COMPANIES_FAILED,
  FETCH_COMPANIES_SUCCESS,
  SET_SELECTED_COMPANY,
} from "../store/types";

const INITIAL_STATE = {
  companies: null,
  selectedCompany: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const companyreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COMPANIES:
    case EDIT_COMPANY:
      return {
        ...state,
        loading: true,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.payload,
        loading: false
      };
    case FETCH_COMPANIES_FAILED:
    case EDIT_COMPANY_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCompany: action.payload || state.selectedCompany
      };
    case SET_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: action.payload
      };
    default:
      return state;
  }
};
